<template>
  <div class="findpasswordTypePage">   
  <XR-head titleText="选择找回方式" :rightShow="false" ref="head"></XR-head>
   
    <mu-list class="checkType">
      <mu-list-item  title="手机" to="/findpassword">
        <mu-icon slot="left" value=":fa fa-phone"/>
        <mu-icon value=":fa fa-angle-right" slot="right"></mu-icon>
      </mu-list-item>
      <mu-divider shallowInset/>
      <mu-list-item  title="邮箱" to="/emailfindpassword">
        <mu-icon slot="left" value=":fa fa-envelope-o"/>
        <mu-icon value=":fa fa-angle-right" slot="right"></mu-icon>
      </mu-list-item>
      <mu-divider shallowInset/>
    </mu-list>
    <XR-toast ref="XRtoast"></XR-toast>
</div>
</template>
<script>
export default {
  data () {
    return {
    }
  }
}
</script>
<style>
    body .findpasswordTypePage{
      
      background: #fff;
    }
    .findpasswordTypePage .checkType{
      padding: 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/FindPasswordType.vue